import { Row } from 'components/Row';
import styled from 'styled-components';

export const Container = styled.div`
  cursor: pointer;
  width: 100%;
`;

export const Label = styled.span<{ $color?: string }>`
  font-size: 12px;
  color: ${({ $color, theme }) => $color || theme.colors.shaft};
  ${({ theme }) => theme.fonts.semiBold};
  text-transform: uppercase;
`;

export const InfoTitle = styled.span`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.shaft};
  ${({ theme }) => theme.fonts.semiBold};
`;

export const InfoDescription = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gulfStream};
  ${({ theme }) => theme.fonts.regular};
`;

export const Thumb = styled.div`
  background: ${({ theme }) => theme.colors.white};
  position: relative;
  transition: all 0.3s ease-out;
  box-shadow: 0px 2px 12px 0px ${({ theme }) => theme.shadows.black(0.08)};

  &:hover {
    box-shadow: 0px 8px 24px 0px ${({ theme }) => theme.shadows.black(0.15)};
    transform: translateY(-3px);
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 240px;
  object-fit: cover;
  display: block;
`;

export const TopLabel = styled(Row)`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  margin: 12px;
`;

export const InfoContainer = styled(Row)`
  padding: 16px;
`;

export const NotAvailable = styled.div`
  background: ${({ theme }) => theme.colors.gulfStream};
  position: absolute;
  padding: 4px 16px;
`;
